import React from "react";
import { SectionCard } from "../../../components/ui";

export default function EventBattlesPanel({ children }) {
  return (
    <SectionCard className="events-panel-shell events-panel-battles" sx={{ p: 1.75 }}>
      <div className="events-panel-header">
        <h4>Battle Log</h4>
        <span>Record and review engagements for this event.</span>
      </div>
      <div className="events-panel-content">{children}</div>
    </SectionCard>
  );
}
